import { FC } from "react";
import UIButtonProps from "../UIButtonProps";
import { Box, Icon, IconButton, Link, styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import UIButton from "../UIButton";
import colors from "@/utils/colorsV2";
interface UIButtonTooltipProps extends UIButtonProps {
  tooltipContent: React.ReactNode | string;
  onlyIcon?: boolean;
  onlyText?: boolean;
  placement?: "top" | "bottom" | "left" | "right";
}

const StyledIconButton = styled(IconButton)({
  width: "36px",
  height: "36px",
  "&:hover": {
    backgroundColor: colors.grayLM100,
  },
})

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const UIButtonTooltip: FC<UIButtonTooltipProps> = ({
  color,
  size,
  textSize,
  label,
  onClick,
  disabled,
  fullWidth = false,
  sx,
  startIcon,
  endIcon,
  onlyIcon = false,
  onlyText = false,
  tooltipContent,
  placement = "top",
}) => {
  return <StyledTooltip title={disabled ? "" : tooltipContent} placement={placement} arrow color="black">
    <Box sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: fullWidth ? '100%' : 'auto',
    }}>
      {onlyIcon && <StyledIconButton type="button" sx={{ width: "36px", height: "36px", ...sx }} aria-label="Clear" onClick={onClick} disabled={disabled}>
        {startIcon}
      </StyledIconButton>}
      {onlyText && (
        <Link
          component={'a'}
          href="#"
          onClick={(e) => { onClick && onClick(e as any) }}
          sx={{ textDecoration: 'none', color: 'inherit' }}
          aria-disabled={disabled}
          tabIndex={disabled ? -1 : 0}
          style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
        >
          {label}
        </Link>
      )}
      {(!onlyIcon && !onlyText) &&
        <UIButton
          color={color}
          size={size}
          textSize={textSize}
          label={label}
          onClick={onClick}
          disabled={disabled}
          fullWidth={fullWidth}
          sx={sx}
          startIcon={startIcon}
          endIcon={endIcon}
        />}
    </Box>
  </StyledTooltip>;
}

UIButtonTooltip.displayName = "UIButtonTooltip";
export default UIButtonTooltip;